function findCounterPart(listTrials,listCounterPart,listType)
{
  var indexes = [];
  for (var i = 0; i < listCounterPart.length; i++)
  {
    if (listCounterPart[i]!="na" && listType[i]=="instructions")
    {
      indexes.push(i);
    }
  }
  stimOrderCounterPart = [];
  for (var i = 0; i < indexes.length; i++)
  {
    stimOrderCounterPart[indexes[i]] = 'Part ' + (i+1) + ' of ' + indexes.length;
  }  

  return stimOrderCounterPart;
}